module.exports = __webpack_public_path__ + "img/invoice-app.05f34559.jpg";